import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiAdminUpdateSettings } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminSettings = () => {
  const [heroImage, setHeroImage] = useState("");
  const [siteAnnouncement, setSiteAnnouncement] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${BASE}/settings`).then(({ data }) => {
      setHeroImage(data.heroImage || "");
      setSiteAnnouncement(data.siteAnnouncement || "");
    });
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await apiAdminUpdateSettings({ heroImage, siteAnnouncement });
      toast.success("Settings saved");
    } catch (err) {
      toast.error("Failed to save");
    }
    setSaving(false);
  };

  return (
    <div className="p-10 max-w-3xl">
      <div className="flex items-center gap-3 mb-2"><div className="h-px w-8 bg-[#b91c1c]" /><span className="text-[10px] font-semibold tracking-[0.32em] uppercase text-[#b91c1c]">Site</span></div>
      <h1 className="font-display text-4xl font-semibold text-[#0a0a0a] tracking-tight mb-8">Settings</h1>

      <form onSubmit={onSave} className="space-y-6 bg-white border border-gray-200 p-8">
        <div>
          <Label>Homepage Hero Image URL (override)</Label>
          <Input value={heroImage} onChange={(e) => setHeroImage(e.target.value)} placeholder="Leave blank to use default" className="mt-2 rounded-none" />
          {heroImage && <img src={heroImage} alt="hero" className="mt-3 max-h-48 border border-gray-200 bg-white" />}
        </div>
        <div>
          <Label>Site Announcement (announcement bar custom message)</Label>
          <Input value={siteAnnouncement} onChange={(e) => setSiteAnnouncement(e.target.value)} placeholder="e.g. HOLIDAY SALE — USE CODE CW25" className="mt-2 rounded-none" />
        </div>
        <Button type="submit" disabled={saving} className="btn-primary rounded-none h-11 px-6 text-[12px] font-semibold uppercase tracking-[0.18em]">
          {saving ? "Saving…" : "Save Settings"}
        </Button>
      </form>
    </div>
  );
};

export default AdminSettings;
